import React from "react";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import zhCN from "antd/lib/locale-provider/zh_CN";

import Reducer from "./reducers";
import Login from "./containers/Login";
import InitReducer from "./initReducer";
import Layout from "./components/Layout";
import Async from "./components/Common/Async";
import configureStore from "./configureStore";
import LiveShowMirrow from "./components/LiveShow/Mirrow";

import "./index.scss";

//  人脸识别
const PersonList = Async(() => import("./containers/Person/index.js"));
//  相册
const GalleryList = Async(() => import("./containers/Gallery/List.js"));
//  直播剪辑
const FromOrder = Async(() => import("./containers/Gallery/FromOrder.js"));
const StatList = Async(() => import("./containers/Stat/index"));
const CommentList = Async(() => import("./containers/Comment/gallery.js"));
const ActiveList = Async(() => import("./containers/Active/index.js"));
const PayList = Async(() => import("./containers/Pay/index.js"));
const QualityList = Async(() => import("./containers/QualityList/index.js"));

//  带layout的页面, 左边有菜单, 顶部 代办事项, 通知, 用户信息等
const PAGES = [
  {
    path: "/page/dashboard",
    title: "看板",
    component: Async(() => import("./containers/Dashboard/DashboardIndex")),
  },
  {
    path: "/page/admin/department",
    title: "部门员工",
    component: Async(() => import("./containers/Department/index")),
  },
  {
    path: "/page/admin/notice",
    title: "通知管理",
    component: Async(() => import("./containers/NoticeList/index")),
  },
  {
    path: "/page/admin/log",
    title: "系统日志",
    component: Async(() => import("./containers/LogList/index")),
  },
  {
    path: "/page/admin/appupdate",
    title: "APP更新",
    component: Async(() => import("./containers/AppUpdate/index")),
  },
  {
    path: "/page/clue/list",
    title: "线索",
    component: Async(() => import("./containers/ClueList/index")),
  },
  // {path:"/page/oppo/list", component:Async(()=>import('./containers/OppoList/index'))},
  {
    path: "/page/product/list",
    title: "产品",
    component: Async(() => import("./containers/ProductList/index")),
  },
  {
    path: "/page/remit/list",
    title: "回款",
    component: Async(() => import("./containers/RemitList/index")),
  },
  {
    path: "/page/consumer/list",
    title: "客户",
    component: Async(() => import("./containers/ConsumerList/index")),
  },
  // {path:"/page/bill/list", component:Async(()=>import('./containers/Finance/BillList'))},
  {
    path: "/page/message/list",
    title: "原片消息",
    component: Async(() => import("./containers/Message/List")),
  },
  {
    path: "/page/contact/list",
    title: "联系人",
    component: Async(() => import("./containers/ContactList/index")),
  },
  // {path:"/page/agreement/list", component:Async(()=>import('./containers/Finance/AgreementList'))},
  {
    path: "/page/service/list",
    title: "服务人员",
    component: Async(() => import("./containers/ServiceList/index")),
  },
  {
    path: "/page/order/list",
    title: "订单",
    component: Async(() => import("./containers/Order/List.js")),
  },
  {
    path: "/page/order/detail/:id",
    title: "订单详情",
    component: Async(() => import("./containers/Order/DetailPage")),
  },
  {
    path: "/page/tag/list",
    title: "标签",
    component: Async(() => import("./containers/Tag/List.js")),
  },
  { path: "/page/gallery/list/:id", title: "相册", component: GalleryList },
  { path: "/page/gallery/list", title: "相册", component: GalleryList },
  {
    path: "/page/gallery/viewer",
    component: Async(() => import("./containers/Gallery/Viewer.js")),
  },
  {
    path: "/page/gallery/setting",
    component: Async(() => import("./containers/Gallery/Setting.js")),
  },
  {
    path: "/page/gallery/fromorder/:id/:type",
    title: "跳转相册",
    component: FromOrder,
  },
  {
    path: "/page/gallery/fromorder/:id",
    title: "跳转相册",
    component: FromOrder,
  },
  {
    path: "/page/rate/list",
    title: "评价",
    component: Async(() => import("./containers/RateList/index")),
  },
  { path: "/page/stat/index", title: "统计", component: StatList },
  { path: "/page/stat/index/:key/:id", title: "统计", component: StatList },
  {
    path: "/page/comment/gallery/:galleryid",
    title: "评论",
    component: CommentList,
  },
  { path: "/page/comment/gallery", title: "评论", component: CommentList },
  {
    path: "/page/active/:activekey/:galleryid",
    title: "互动管理",
    component: ActiveList,
  },
  {
    path: "/page/pay/:activekey/:galleryid",
    title: "付费管理",
    component: PayList,
  },
  {
    path: "/page/quality/:activekey/:galleryid",
    title: "品控管理",
    component: QualityList,
  },
  {
    path: "/page/proxy/list",
    title: "代理商",
    component: Async(() => import("./containers/ProxyList/index")),
  },
  {
    path: "/page/checking/list",
    title: "对账单汇总",
    component: Async(() => import("./containers/Check/List")),
  },
  {
    path: "/page/checking/service",
    component: Async(() => import("./containers/Check/Service")),
  },
  {
    path: "/page/checking/finance/:id",
    title: "对账单",
    component: Async(() => import("./components/CheckList/ListForFinance.js")),
  },
  {
    path: "/page/tool/video",
    title: "视频素材",
    component: Async(() => import("./containers/Tool/VideoList")),
  },
  {
    path: "/page/tool/domain",
    title: "域名验证",
    component: Async(() => import("./containers/Tool/DomainList")),
  },
  {
    path: "/page/tool/convert",
    title: "表格转换",
    component: Async(() => import("./containers/Tool/TableConvert")),
  },
  {
    path: "/page/gallery/decorate/:galleryid",
    title: "相册装修",
    component: Async(() => import("./components/DecorateV2/index.js")),
  },
  {
    path: "/page/gallery/image/:id",
    title: "子相册列表",
    component: Async(() => import("./components/FileViewerV2/index.js")),
  },
  { path: "/page/person/list", title: "人脸管理", component: PersonList },
  {
    path: "/page/person/list/:galleryid",
    title: "人脸管理",
    component: PersonList,
  },
  {
    path: "/page/matter/list",
    title: "案例列表",
    component: Async(() => import("./containers/Matter/List.js")),
  },
  {
    path: "/page/video/control/:id",
    title: "直播监控",
    component: Async(() => import("./containers/Video/Control.js")),
  },
  {
    path: "/page/video/old/:orderid/:galleryid",
    title: "媒体资源",
    component: Async(() => import("./containers/Video/List.js")),
  },
  {
    path: "/page/video/list/:orderid/:galleryid",
    title: "媒体资源",
    component: Async(() => import("./containers/Video/List.js")),
  },
  {
    path: "/page/video/listnew/:orderid/:galleryid",
    title: "媒体资源",
    component: Async(() => import("./containers/Video/index.js")),
  },
  {
    path: "/page/consumer-face/:consumerId",
    title: "人脸识别",
    component: Async(() => import("./containers/Face/comsumer-face-list.js")),
  },
  {
    path: "/page/face/:orderid/:galleryid",
    title: "人脸识别",
    component: Async(() => import("./containers/Face/index.js")),
    explain: "这个链接被启用了, 但是功能依然正常, 可以恢复",
  },
  {
    path: "/page/visit/:galleryid/:linkid",
    title: "权限管理",
    component: Async(() => import("./containers/Visit/List.js")),
  },
  {
    path: "/page/visit/:galleryid",
    title: "权限管理",
    component: Async(() => import("./containers/Visit/List.js")),
  },
  {
    //  /page/video/listnew/:orderId/:galleryId/:projectId
    path: "/page/video/listnew/:orderId/:galleryId/:projectId",
    title: "视频列表",
    component: Async(() => import("./containers/Video/compose.js")),
  },
];

//  全屏页面, 不带layout
const FULL_PAGES = [
  {
    path: "/page/cuteditor/video",
    title: "视频剪辑",
    component: Async(() => import("./containers/CutEditor/Video.js")),
  },
  {
    path: "/page/cuteditor/live",
    title: "直播剪辑",
    component: Async(() => import("./containers/CutEditor/Live.js")),
  },
  {
    path: "/page/quality/allinone",
    title: "品控三合一",
    component: Async(() => import("./containers/Quality/AllInOne.js")),
  },
];
//store
let store = configureStore(Reducer, InitReducer);
class TheApp extends React.Component {
  componentDidMount() {
    //  console.log(window.showDirectoryPicker);
  }

  render() {
    return (
      <Router>
        <Route
          render={(route) => {
            return (
              <Switch>
                <Route
                  path="/loginpass"
                  render={(route) => <Login router={route} />}
                />
                <Route
                  path="/page/liveshow/mirrow/:galleryid"
                  render={(route) => <LiveShowMirrow router={route} />}
                />
                {FULL_PAGES.map((it) => {
                  return (
                    <Route
                      path={it.path}
                      key={it.path}
                      exact
                      render={(props) => {
                        let Component = it.component;
                        window.document.title = `${it.title} - 即享CRM`;
                        return <Component {...props} />;
                      }}
                    />
                  );
                })}
                <Route>
                  <Layout router={route}>
                    <Switch>
                      {PAGES.map((it) => {
                        return (
                          <Route
                            path={it.path}
                            key={it.path}
                            exact
                            render={(props) => {
                              let Component = it.component;
                              window.document.title = `${it.title} - 即享CRM`;
                              return <Component {...props} />;
                            }}
                          />
                        );
                      })}
                      <Redirect to="/page/dashboard" />
                    </Switch>
                  </Layout>
                </Route>
                <Redirect to="/page/dashboard" />
              </Switch>
            );
          }}
        />
      </Router>
    );
  }
}

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <TheApp />
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js